import { IBudgetUnitFilterRequest } from '../../../../model/sge/budget-unit/request/budget-unit-filter-request';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

export type BudgetUnitSearchState = {
    parameters: IBudgetUnitFilterRequest;
    searchTrigger: number;
    drawer: { open: boolean; record?: IBudgetUnitResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const BudgetUnitSearchReducer = (state: BudgetUnitSearchState, action: any): BudgetUnitSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, record: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
